"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIDE_BY_SIDE = exports.OVERLAY = exports.DIFF = exports.iBimUploadFailureEvent = exports.BIM_UPLOAD_FAILURE_EVENT = exports.iBimUploadEvent = exports.BIM_UPLOAD_EVENT = exports.iMoveFilesOverlayMode = exports.MOVE_FROM_SELECTION_CART = exports.COPY_FROM_SELECTION_CART = exports.IMPORT = exports.COPY = exports.MOVE = exports.defaultNotificationOptions = exports.iNotificationOptions = exports.iNotificationsOptionsOverlayStatus = exports.FOLDER = exports.iCreateProjectMetadata = exports.iMetadataOption = exports.closed = exports.iClosed = exports.CLOSED = exports.iOpen = exports.OPEN = exports.iMissingOrDefined = exports.DESC = exports.ASC = exports.TEMPLATE = exports.REPORT = exports.DOWN = exports.UP = exports.BookmarkURL = exports.SELECTION = exports.PROJECT = exports.NODE = exports.DEFINED = exports.MISSING = exports.ANY = exports.FAILED = exports.SAVED = exports.SAVING = exports.EDITED = exports.ERROR = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const t = require("io-ts");
const sok_types_1 = require("@caddigital/sok-types");
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.ERROR = 'ERROR';
exports.EDITED = 'EDITED';
exports.SAVING = 'SAVING';
exports.SAVED = 'SAVED';
exports.FAILED = 'FAILED';
exports.ANY = 'ANY';
exports.MISSING = 'MISSING';
exports.DEFINED = 'DEFINED';
exports.NODE = 'NODE';
exports.PROJECT = 'PROJECT';
exports.SELECTION = 'SELECTION';
exports.BookmarkURL = '/api/files/bookmark';
exports.UP = 'UP';
exports.DOWN = 'DOWN';
exports.REPORT = 'REPORT';
exports.TEMPLATE = 'TEMPLATE';
exports.ASC = 'asc';
exports.DESC = 'desc';
function iMissingOrDefined(value) {
    return t.union([
        t.interface({
            type: t.literal(exports.MISSING)
        }),
        t.interface({
            type: t.literal(exports.DEFINED),
            value: value
        })
    ]);
}
exports.iMissingOrDefined = iMissingOrDefined;
exports.OPEN = 'OPEN';
exports.iOpen = t.literal(exports.OPEN);
exports.CLOSED = 'CLOSED';
exports.iClosed = t.interface({
    type: t.literal(exports.CLOSED)
});
exports.closed = {
    type: exports.CLOSED
};
exports.iMetadataOption = t.interface({
    name: t.string,
    value: t.string
});
exports.iCreateProjectMetadata = t.interface({
    project_id: t.number,
    metadata: t.array(sok_types_1.CustomMeta.iMetadata)
});
exports.FOLDER = 'FOLDER';
exports.iNotificationsOptionsOverlayStatus = t.union([
    exports.iClosed,
    t.interface({
        type: t.literal(exports.OPEN),
        status: t.union([
            t.literal(exports.SAVING),
            t.literal(exports.SAVED),
            t.literal(exports.FAILED),
            t.literal(exports.STANDBY)
        ]),
        files: t.array(t.union([sok_types_1.File.iRevisionOrFolder, sok_types_1.File.iRevisionOrFolderSimplified])),
        projectName: t.string
    })
]);
exports.iNotificationOptions = t.interface({
    email: t.boolean,
    push: t.boolean
});
exports.defaultNotificationOptions = {
    email: false,
    push: false
};
exports.MOVE = 'MOVE';
exports.COPY = 'COPY';
exports.IMPORT = 'IMPORT';
exports.COPY_FROM_SELECTION_CART = 'COPY_FROM_SELECTION_CART';
exports.MOVE_FROM_SELECTION_CART = 'MOVE_FROM_SELECTION_CART';
exports.iMoveFilesOverlayMode = t.union([
    t.literal(exports.MOVE),
    t.literal(exports.COPY),
    t.literal(exports.IMPORT),
    t.literal(exports.CLOSED),
    t.literal(exports.COPY_FROM_SELECTION_CART),
    t.literal(exports.MOVE_FROM_SELECTION_CART)
]);
exports.BIM_UPLOAD_EVENT = 'BIM_UPLOAD_EVENT';
exports.iBimUploadEvent = t.interface({
    event: t.literal(exports.BIM_UPLOAD_EVENT),
    message: t.interface({
        fileRevisionUuid: t.string,
        bimRevisionId: t.string
    })
});
exports.BIM_UPLOAD_FAILURE_EVENT = 'BIM_UPLOAD_FAILURE_EVENT';
exports.iBimUploadFailureEvent = t.interface({
    event: t.literal(exports.BIM_UPLOAD_FAILURE_EVENT),
    message: t.interface({
        fileRevisionUuid: t.string
    })
});
exports.DIFF = 'DIFF';
exports.OVERLAY = 'OVERLAY';
exports.SIDE_BY_SIDE = 'SIDE_BY_SIDE';
//# sourceMappingURL=types.js.map